/* tslint:disable */

/**
 */
export class Symbol {
    prodDimensionSymbol?: string;
    productFlowSymbol?: string;
    temperatureSymbol?: string;
    percentSymbol?: string;
    timeSymbol?: string;
    perUnitOfMassSymbol?: string;
    enthalpySymbol?: string;
    monetarySymbol?: string;
    equipDimensionSymbol?: string;
    convectionSpeedSymbol?: string;
    prodchartDimensionSymbol?: string;
    massSymbol?: string;
    consumSymbol?: string;
    consumMaintienSymbol?: string;
    mefSymbol?: string;
    meshesSymbol?: string;
    packingThicknessSymbol?: string;
    shelvesWidthSymbol?: string;
    lineDimensionSymbol?: string;
    pressureSymbol?: string;
    materialRiseSymbol?: string;
    convectionCoeffSymbol?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/symbol.ts